import axios, { AxiosRequestConfig } from 'axios';
import { NavigateFunction } from 'react-router-dom';
import { clearSessionCredentials } from '../globalFunctions';
import { SchoolClass } from '../types';

export class SchoolClassDAO {
    static async save(token: string, navigate: NavigateFunction, schoolClass: SchoolClass) {
        if (schoolClass.id > 0) {
            return await SchoolClassDAO.update(token, navigate, schoolClass);
        } else {
            return await SchoolClassDAO.store(token, navigate, schoolClass);
        }
    }

    static async store(token: string, navigate: NavigateFunction, schoolClass: SchoolClass) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/class`,
                schoolClass,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao criar turma',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async update(token: string, navigate: NavigateFunction, schoolClass: SchoolClass) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/class/${schoolClass.id}`,
                schoolClass,
                requestConfig
            );

            return response.data;
        } catch (error: any) {
            const response = {
                message: 'Erro ao atualizar turma',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }

    static async delete(token: string, navigate: NavigateFunction, id: number) {
        try {
            const requestConfig: AxiosRequestConfig = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };

            const response = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/logicmanager/class/${id}`,
                requestConfig
            );

            return response.data === 1;
        } catch (error: any) {
            const response = {
                message: 'Erro ao excluir turma',
                error: error
            };

            if ([401, 419].includes(error.response.status)) {
                // Unauthorized
                clearSessionCredentials(navigate);
            } else {
                console.error(response);
                return response;
            }
        }
    }
}
